var getExternalLinkProps = function() {
    return {
        target: "_blank",
        rel: "noreferrer noopener"
    };
};
export default getExternalLinkProps;
